// This file is manually curated to allow us to expose the generated
// client as we like.
import type { Auth, Asset, AssetService, Realm, Scope, Export, Chat } from "./gen";
import {ConversationRequestSchema, ListRecentChatsRequest} from "./gen/chat/v3/chat_pb";

export const MessageKind = {
  Asset: "assets.v3.Asset",
  AuthSyncRequest: "auth.v3.SyncRequest",
  AvailableRealmWithNames: 'realm.v3.AvailableRealmWithNames',
  CompleteAssetUploadRequest: "assets.v3.CompleteAssetUploadRequest",
  ConversationRequest: "chat.v3.ConversationRequest",
  CreateAssetRequest: "assets.v3.CreateAssetRequest",
  DeleteAssetRequest: "assets.v3.DeleteAssetRequest",
  DeleteAssetsRequest: "assets.v3.DeleteAssetsRequest",
  ExportRichTextRequest: "export.v3.ExportRichTextRequest",
  GenerateSignedURLRequest: "assets.v3.GenerateSignedURLRequest",
  GetAssetsRequest: "assets.v3.GetAssetsRequest",
  ListRecentChatsRequest: "chat.v3.ListRecentChatsRequest",
  RealmWithNames: "realm.v3.RealmWithNames",
  Scope: "query.v3.Scope",
  UploadAssetRequest: "assets.v3.UploadAssetRequest",
};

// =============================================================================
// AUTH
// =============================================================================
export function createAuthSyncRequest(data: Partial<Omit<Auth.SyncRequest, "$typeName">> = {}): Auth.SyncRequest {
  return {
    $typeName: MessageKind.AuthSyncRequest,
    ...data,
  } as Auth.SyncRequest;
}

// =============================================================================
// LABELS
// =============================================================================



// =============================================================================
// ASSETS
// =============================================================================

// Factory to create a type safe Delete Assets request to be used in the client
export function createDeleteAssets(data: Partial<Omit<AssetService.DeleteAssetsRequest, "$typeName">> = {}): AssetService.DeleteAssetsRequest {
  return {
    $typeName: MessageKind.DeleteAssetsRequest,
    ...data,
  } as AssetService.DeleteAssetsRequest;
}

// Factory to create a type safe Delete Assets request to be used in the client
export function createDeleteAsset(data: Partial<Omit<AssetService.DeleteAssetRequest, "$typeName">> = {}): AssetService.DeleteAssetRequest {
  return {
    $typeName: MessageKind.DeleteAssetRequest,
    ...data,
  } as AssetService.DeleteAssetRequest;
}

// Factory to create a type safe Asset to be used in the client
export function createAsset(data: Partial<Omit<Asset.Asset, "$typeName">> = {}): Asset.Asset {
  return {
    $typeName: MessageKind.Asset,
    ...data,
  } as Asset.Asset;
}

export function createCompleteAssetUploadRequest(
  data: Partial<Omit<AssetService.CompleteAssetUploadRequest, "$typeName">> = {},
): AssetService.CompleteAssetUploadRequest {
  return {
    $typeName: MessageKind.CompleteAssetUploadRequest,
    ...data,
  } as AssetService.CompleteAssetUploadRequest;
}

export function createCreateAssetRequest(
  data: Partial<Omit<AssetService.CreateAssetRequest, "$typeName">> = {},
): AssetService.CreateAssetRequest {
  return {
    $typeName: MessageKind.CreateAssetRequest,
    ...data,
  } as AssetService.CreateAssetRequest;
}

export function createGenerateSignedUrlRequest(
  data: Partial<Omit<AssetService.GenerateSignedURLRequest, "$typeName">> = {},
): AssetService.GenerateSignedURLRequest {
  return {
    $typeName: MessageKind.GenerateSignedURLRequest,
    ...data,
  } as AssetService.GenerateSignedURLRequest;
}

export function createGetAssetsRequest(
  data: Partial<Omit<AssetService.GetAssetsRequest, "$typeName">> = {},
): AssetService.GetAssetsRequest {
  return {
    $typeName: MessageKind.GetAssetsRequest,
    ...data,
  } as AssetService.GetAssetsRequest;
}

export function createUploadAssetRequest(
  data: Partial<Omit<AssetService.UploadAssetRequest, "$typeName">> = {},
): AssetService.UploadAssetRequest {
  return {
    $typeName: MessageKind.UploadAssetRequest,
    ...data,
  } as AssetService.UploadAssetRequest;
}

// =============================================================================
// REALMS
// =============================================================================
export function createRealmWithNames(
  data: Partial<Omit<Realm.RealmWithNames, "$typeName">> = {},
): Realm.RealmWithNames {
  return {
    $typeName: MessageKind.RealmWithNames,
    ...data,
  } as Realm.RealmWithNames;
}

// =============================================================================
// Chat
// =============================================================================
export function createListRecentChatsRequest(data: Partial<Omit<Chat.ListRecentChatsRequest, "$typeName">> = {}): Chat.ListRecentChatsRequest {
  return {
    $typeName: MessageKind.ListRecentChatsRequest,
    ...data,
  } as Chat.ListRecentChatsRequest;
}

export function createScope(data: Partial<Omit<Scope.Scope, "$typeName">> = {}): Scope.Scope {
  return {
    $typeName: MessageKind.Scope,
    ...data,
  } as Scope.Scope;
}
export function createConversationRequest(data: Partial<Omit<Chat.ConversationRequest, "$typeName">> = {}): Chat.ConversationRequest {
  return {
    $typeName: MessageKind.ConversationRequest,
    ...data,
  } as Chat.ConversationRequest;
}

// =============================================================================
// EXPORT
// =============================================================================
export function createExportRichTextRequest(
  data: Partial<Omit<Export.ExportRichTextRequest, "$typeName">> = {},
): Export.ExportRichTextRequest {
  return {
    $typeName: MessageKind.ExportRichTextRequest,
    ...data,
  } as Export.ExportRichTextRequest;
}
